<template>
  <Bar
      id="my-chart-id"
      :options="options"
      :data="chartData"
  />
</template>
<script>
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

    export default {
        name: "Chart",
        extends: Bar,
        //mixins: [mixins.reactiveProp],
        props: ['chartData', 'options'],
        data: () => ({}),
        mounted() {
            //this.addPlugins(ChartJSPluginDatalabels);
            //this.renderChart(this.chartData, this.options);
        }
    }
</script>

<style>
</style>